import lang from "translations";

export const UnSyncTransactionReportColumns = [
  {
    key: "venueId",
    text: lang.id,
  },
  {
    key: "venueName",
    text: lang.venueName,
  },
  {
    key: "errorMessage",
    text: lang.error,
  },
  {
    key: "errorCount",
    text: lang.count,
  }
];
